
/**
 * Creates a unique hash of transaction data for duplication detection
 * This function produces a deterministic string representation of the key transaction fields
 * that can be used to identify duplicate transaction attempts
 */
export const createTransactionHash = (data: any): string => {
  // Filter out null/undefined values and normalize the data
  const normalizedData = {
    type: data.type || '',
    customer_id: data.customer_id || '',
    amount: Number(data.amount || 0).toFixed(2), // Normalize to 2 decimal places
    name: (data.name || '').trim().toLowerCase(), // Normalize case
    description: (data.description || '').trim().toLowerCase(), // Normalize case
    payment_method: (data.payment_method || '').toLowerCase(), // Normalize case
    payment_status: (data.payment_status || '').toLowerCase(), // Normalize case
    category: (data.category || '').toLowerCase(), // Normalize case
    due_date: data.due_date || '',
    // Include timestamp within a minute window to allow duplicate detection within that window
    // but prevent false positives across longer time periods
    timeWindow: Math.floor(Date.now() / (1000 * 60)), // 1-minute window
  };
  
  // Create a sorted version of the object for consistency regardless of property order
  const sortedEntries = Object.entries(normalizedData)
    .filter(([_, value]) => value !== null && value !== undefined && value !== '')
    .sort(([keyA], [keyB]) => keyA.localeCompare(keyB));
  
  // Create a stable string representation
  return JSON.stringify(Object.fromEntries(sortedEntries));
};
